<template>
  <v-card flat dense>
    <v-card-title>
      <div class="d-inline-flex align-baseline">
        <span class="mr-4">{{
          $t('INHABITANT_CHANGES.CHECK_IN_REQUEST')
        }}</span>
      </div>
      <v-spacer />
      <span class="text-body-2">{{ $t('ITEM.STATUS') }}</span>
      <div>
        <v-select
          v-model="request.status_id"
          name="status_id"
          :items="statusesList"
          item-value="id"
          item-text="name"
          small-chips
          hide-details
          dense
          flat
          solo
          style="width: 170px"
          :error-messages="errors.action"
          @change="clearErrorByName('status')"
        >
          <template v-slot:selection="{ attrs, item, select, selected }">
            <v-chip
              :color="item.color"
              :input-value="selected"
              text-color="white"
              small
              v-bind="attrs"
              @click="select"
            >
              {{ item.name }}
            </v-chip>
          </template>
        </v-select>
      </div>
      <v-btn icon @click="cancel">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-card-title>

    <v-card-text>
      <v-form v-if="request.id" ref="form" v-model="valid" lazy-validation>
        <v-row>
          <v-col>
            <person-form
              v-model="request.data.person"
              :readonly="!editable"
              :errors="errors.get('data.person')"
              @update-prop="clearErrorByName($event, 'data.person')"
            />
            <personal-profile-form
              v-model="request.data.personal_profile"
              :readonly="!editable"
              :errors="errors.get('data.personal_profile')"
              @update-prop="clearErrorByName($event, 'data.personal_profile')"
            />
            <v-textarea
              v-model="request.data.personal_profile.add_info"
              :label="$t('ITEM.ADDITIONAL_INFO')"
              :readonly="!editable"
              :rules="rules.textDescription"
              :counter="1500"
              rows="2"
              :error-messages="errors.get('data.personal_profile.add_info')"
              @update-prop="clearErrorByName($event, 'data.personal_profile')"
            />
            <user-information-form
              v-model="request.data.user"
              :readonly="!editable"
              :errors="errors.get('data.user')"
              @update-prop="clearErrorByName($event, 'data.user')"
            />
            <inhabitant-form
              v-model="request.data.inhabitant"
              :readonly="!editable"
              :errors="errors.get('data.inhabitant')"
              @update-prop="clearErrorByName($event, 'data.inhabitant')"
            />
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>

    <v-card-actions>
      <slot name="buttons" :valid="valid" :cancel="cancel" :update="update">
        <v-btn large outlined depressed color="grey" @click="cancel">{{
          $t('BUTTON.CANCEL')
        }}</v-btn>
        <v-spacer />
        <v-btn
          large
          depressed
          color="primary"
          :disabled="!isEnabledUpdateButton"
          @click="validableUpdate"
        >
          {{ $t('BUTTON.UPDATE') }}
        </v-btn>
      </slot>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapActions } from 'vuex';
import errors from '@/modules/_global/mixins/errors';
import i18nRefreshData from '@/modules/_global/mixins/i18nRefreshData';
import { textDescription } from '@/modules/_global/variables/rules';
import request from '@/modules/inhabitant_changes/components/requests/mixins/request';
import PersonForm from '@/modules/persons/components/forms/PersonForm';
import InhabitantForm from '@/modules/persons/components/forms/InhabitantForm';
import UserInformationForm from '@/modules/persons/components/forms/UserInformationForm';
import PersonalProfileForm from '@/modules/persons/components/forms/PersonalProfileForm';

export default {
  name: 'RequestCheckIn',

  components: {
    PersonForm,
    InhabitantForm,
    PersonalProfileForm,
    UserInformationForm
  },

  mixins: [request, errors, i18nRefreshData],

  props: {
    id: {
      type: Number,
      required: true
    }
  },

  data: () => ({
    request: {
      data: {
        user: {},
        person: {},
        personal_profile: {},
        inhabitant: {}
      },
      status: {},
      person: {}
    },
    rules: {
      add_info: textDescription
    }
  }),

  mounted() {
    this.refreshData();
  },

  methods: {
    ...mapActions('inhabitant_changes', [
      'getById',
      'getStatuses',
      'resolveRequest'
    ]),

    refreshData() {
      this.getById(this.id).then(({ data: { data: request } }) => {
        const { apartment, data } = request;

        this.request = {
          ...request,
          data: {
            ...data,
            inhabitant: {
              apartment,
              ...data.inhabitant
            }
          }
        };
      });

      this.getStatuses().then(({ data }) => {
        this.statuses = data.data;
      });
    },

    validate() {
      return this.$refs.form.validate();
    },

    update() {
      this.resolveRequest({
        id: this.id,
        data: this.request
      })
        .then(() => {
          this.$emit('updated');
        })
        .catch(({ response }) => {
          this.handleErrorsByResponse(response);
        });
    },

    cancel() {
      this.$emit('cancel');
    }
  }
};
</script>
